import styled, { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    /* font-family: "Prompt", sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* font-family: 'Roboto Condensed', sans-serif; */
    background: linear-gradient(116.67deg, rgba(57, 124, 221, 0.2) 0%, rgba(17, 155, 31, 0.2) 100.98%);
    overflow: hidden;
  }
  *,
  *::after,
  *::before {
  box-sizing : border-box;
  margin : 0;
  padding : 0;
  font-family : 'Roboto', sans-serif;
  /* font-family: 'Montserrat', sans-serif; */
}
`;

export const Container = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 50px;
  padding-left: 50px;

  @media screen and (max-width: 991px) {
    padding-right: 30px;
    padding-left: 30px;
  }
`;

export const Button = styled.button`
  border-radius: 4px;
  background: ${({ primary }) => (primary ? '#4b59f7' : '#0467fb')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '12px 64px' : '10px 20px')};
  color: #fff;
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '16px')};
  outline: none;
  border: none;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease-out;
    background: #fff;
    background: ${({ primary }) => (primary ? '#0467fb' : '#4b59f7')};

    @media srceen and (max-width: 960px) {
      width: 100%;
    }
  }
`;

export default GlobalStyle;
